import React from "react";

import { Portlet, PortletTitle } from "~/components/ui/portlet";
import { PublicLayout } from "~/components/ui/public-layout";
import { useIntlDocumentTitle } from "~/hooks/use-document-title";

/**
 * The PUBLIC `/contacts` page (reachable logged-out). Inside the redesign shell a signed-in doctor gets
 * `redesign-v1/legal/contacts-page.tsx` instead — rebuilt on the redesign conventions, which
 * is why the `bareLayout` prop this briefly carried is gone: nothing wraps this body any more.
 */
export default function Contacts() {
  useIntlDocumentTitle("page.footer.contacts");

  return (
    <PublicLayout>
      <Portlet as="main">
        <PortletTitle iconClassName="icon-user-follow">Контактные данные организации</PortletTitle>
        <div className="portlet-body form">
          <h3>Адрес и телефон:</h3>
          <p>
            121205, Москва <br />
            Территория Инновационного Центра «Сколково» <br />
            Большой бульвар, 42, корп. 1<br />
            Лаборатория &quot;3D Smile&quot; <br />
            <br />
            +7 (495) 211-44-54 <br />
            <br />
            Электронная почта: <br />
            info@3d-smile.ru <br />
          </p>
          <h3>Реквизиты:</h3>
          <p>
            Общество с ограниченной ответственностью «3Д Смайл» <br />
            ОГРН 1267700173641 <br />
            ИНН/КПП 9728173887/772801001 <br />
            Юридический адрес: 121205, Москва, Территория Инновационного Центра «Сколково»,
            Технопарк, Большой бульвар, 42, корп. 1<br />
          </p>
        </div>
      </Portlet>
    </PublicLayout>
  );
}
